export default __webpack_public_path__ + "static/media/apple-MagicKeyboard.245c07d7.jpg";